export default "__VITE_ASSET__BI$IWHAP__"